@if (result(); as sim) {
  <h3 class="shown-hidden">{{ sim.shown ? 'Shown' : 'Hidden' }}</h3>
  <h4 class="rule-name">by {{ sim.noMatch ? '' : sim.shown ? 'Show' : 'Hide' }} {{ sim.rule?.name }}</h4>

  @if (sim.styledByPartialRules && sim.styledByPartialRules.length > 0) {
    <div class="summary-section">
      Styled by partial rules:
      @for (rule of sim.styledByPartialRules; track $index) {
        <div>- {{ rule.ruleDescription.name }}</div>
      }
    </div>
  }

  @if (sim.warnings && sim.warnings.length > 0) {
    <div class="summary-section">
      <strong>Warnings ({{ sim.warnings.length }}):</strong>
      <ul>
        @for (warning of sim.warnings; track $index) {
          <li class="warning-text">{{ warning }}</li>
        }
      </ul>
    </div>
  }
}
